import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../services/apiClient";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  MailOutlined,
  ArrowLeftOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { ThemeContext } from "../context/ThemeContext";
import "./ForgotPassword.css";
import logoShort from "../assets/logoShort.png";
import { message } from "antd";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { isDark, toggleTheme } = useContext(ThemeContext);
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const baseUrl = process.env.REACT_APP_AUTH_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      console.log("Sending forgot password request for:", email);
      const response = await apiClient.post(`${baseUrl}/user/forgot-password`, {
        email: email,
      });

      console.log("Forgot Password Response:", response.data);

      if (response.data.success) {
        // Show the exact message from API response
        message.success(response.data.message, {
          duration: 5,
        });
        // toast.success(response.data.message, {
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   theme: isDark ? "dark" : "light",
        // });

        // Clear form and navigate back to login
        setEmail("");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        throw new Error(response.data.message || "Failed to send reset link");
      }
    } catch (error) {
      console.error("Forgot Password Error:", error);
      const errorMessage = error.response?.data?.message || error.message || "Failed to send reset link";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: isDark ? "dark" : "light",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-background">
        <div className="background-pattern"></div>
      </div>

      <div className="forgot-password-content">
        {/* Left Side - Hero Section */}
        <div className="forgot-password-hero">
          <div className="floating-elements">
            <div className="floating-element"></div>
            <div className="floating-element"></div>
            <div className="floating-element"></div>
            <div className="floating-element"></div>
          </div>

          <div className="hero-content">
            <h1 className="hero-title">Reset Your Password</h1>
            <p className="hero-subtitle">
              Don't worry! It happens to the best of us. Enter your email address
              and we'll send you a link to reset your password.
            </p>

            <div className="hero-features">
              <div className="hero-feature">
                <div className="hero-feature-icon">🔐</div>
                <span>Secure Password Reset</span>
              </div>
              <div className="hero-feature">
                <div className="hero-feature-icon">📧</div>
                <span>Email Verification</span>
              </div>
              <div className="hero-feature">
                <div className="hero-feature-icon">⚡</div>
                <span>Quick & Easy Process</span>
              </div>
              <div className="hero-feature">
                <div className="hero-feature-icon">🛡️</div>
                <span>24/7 Security</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Form Section */}
        <div className="forgot-password-form-section">
          <div className="forgot-password-card">
            {/* Theme Toggle */}
            <button
              className="theme-toggle-btn"
              onClick={toggleTheme}
              title={`Switch to ${isDark ? "light" : "dark"} mode`}
            >
              {isDark ? "☀️" : "🌙"}
            </button>

            {/* Header */}
            <div className="forgot-password-header">
              <div className="logo-section">
                <img src={logoShort} alt="SimplyBond" className="logo" />
                <h1 className="title">SimplyBond</h1>
              </div>
              <p className="subtitle">
                Enter your email address to receive a password reset link
              </p>
            </div>

            {/* Form */}
            <form className="forgot-password-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">
                  <MailOutlined />
                  Email Address
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                  placeholder="Enter your email address"
                  required
                />
              </div>

              <button type="submit" className="submit-btn" disabled={isLoading}>
                {isLoading ? "Sending..." : "Send Reset Link"}
              </button>

              <button
                type="button"
                className="back-to-login-btn"
                onClick={handleBackToLogin}
              >
                <ArrowLeftOutlined />
                Back to Login
              </button>
            </form>

            {/* Additional Info */}
            <div className="info-section">
              <div className="info-item">
                <LockOutlined className="info-icon" />
                <div className="info-content">
                  <h4>Secure Process</h4>
                  <p>Your email address is only used for password reset</p>
                </div>
              </div>
              <div className="info-item">
                <MailOutlined className="info-icon" />
                <div className="info-content">
                  <h4>Check Your Email</h4>
                  <p>Reset link will be sent to your registered email</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 